import {
  getJson
} from '../fetch';
import API_BASE_PATH from './basePath';

// eslint-disable-next-line import/prefer-default-export
export const getAuditEventsPage = (page, size, sortBy, sortDir) => {
  let requestUrl = `${API_BASE_PATH}/audit-events?page=${page}&size=${size}`;

  if (sortBy) {
    requestUrl = `${requestUrl}&sortBy=${sortBy}`;
  }

  if (sortDir) {
    requestUrl = `${requestUrl}&sortDir=${sortDir}`;
  }

  return getJson(requestUrl);
};
